<template>
<div>
    <Breadcrumbs main="Admin" submain="Shelter" title="Shelter Dashboard" />
    <div class="container-fluid">
        <div class="d-flex flex-column flex-md-row" style="align-items: center;">
            <div class="col-md-3 margin-y-axis">
                <b-form-select v-model="shelter" :options="formattedShelters" @change="updateShelter()"></b-form-select>
            </div>
            <div class="col-md-3" v-if="liveTracking">
                <div>
                    <datepicker placeholder="Select Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="date"></datepicker>
                </div>
            </div>
            <div class="col-md-3 margin-y-axis">
                <div class="d-flex flex-row align-items-center">
                    <span class="pr-2">Live Tracking</span>
                    <div class="text-left icon-state switch-outline">
                        <label class="switch mt-2 ml-2">
                            <input type="checkbox" :checked="liveTracking" @click="toggleLive()"><span class="switch-state bg-primary"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div v-if="liveTracking" class="col-md-3">
                <div class="d-flex flex-row align-items-center">
                    <button @click="calculateRelief()" v-b-modal.modal-relief-center style="width: 100%; background-color: #1e73ed; border: 1px solid #1e73ed; color: white; font-size: large; padding: 8px 8px; border-radius: 0.375rem;">Calculate Relief</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid starts-->

    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div style="width: 100%;" v-if="!loading && !error">
                            <div class="d-flex flex-column flex-md-row">
                                <div class="col-md-4 margin-y-axis">
                                    <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                        <router-link :to="{path:'/house/list', query: { shelter: shelter}  }">
                                            <div class="title">Occupancy
                                                <span>
                                                    <feather class="text-center" type="external-link" size="22"></feather>
                                                </span>
                                            </div>
                                            <div class="count" v-if="count_list_by_shelter.total_member_sum">
                                                <span v-if="liveTracking && count_live_list.total_member_sum>=0">{{ count_live_list.total_member_sum }}/</span>
                                                {{ count_list_by_shelter.total_member_sum }}
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                        <router-link :to="{path:'/house/list', query: { shelter: shelter}  }">
                                            <div class="title">House
                                                <span>
                                                    <feather class="text-center" type="external-link" size="22"></feather>
                                                </span>
                                            </div>
                                            <div class="count" v-if="count_list_by_shelter.home">{{ count_list_by_shelter.home }}</div>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-md-4 margin-y-axis">
                                    <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                        <router-link :to="{ path: '/resources/emergency-contact/list', query: { shelter: shelter } }">
                                            <div>
                                                <div class="title text-center">Emergeny Contact</div>
                                                <div style="padding-top: 8px; border-bottom: 2px solid #1e73ed;"></div>
                                                <div style="text-align: center; font-size: medium; padding: 6px; cursor: pointer; gap: 5px;" class="d-flex flex-row align-items-center justify-content-center">
                                                    <span class="text-center">Details </span>
                                                    <feather class="text-center" type="external-link" size="22"></feather>
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                            <p class="mt-5 main-title">Demographic ({{ count_list_by_shelter.total_member_sum }})</p>
                            <div class="d-flex flex-column flex-md-row">
                                <div class="col-md-4">
                                    <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                        <div>
                                            <div class="title">Male</div>
                                            <div class="count" v-if="count_list_by_shelter.male">
                                                <span v-if="liveTracking && count_live_list.male>=0">{{ count_live_list.male }}/</span>
                                                {{ count_list_by_shelter.male }}
                                            </div>
                                            <div style="padding-top: 8px; border-bottom: 2px solid #1e73ed;"></div>
                                            <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;" v-b-modal.modal-center @click="getDemographicByShelter('Male')">Details</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 margin-y-axis">
                                    <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                        <div>
                                            <div class="title">Female</div>
                                            <div class="count" v-if="count_list_by_shelter.female">
                                                <span v-if="liveTracking && count_live_list.female>=0">{{ count_live_list.female }}/</span>
                                                {{ count_list_by_shelter.female }}</div>
                                            <div style="padding-top: 8px; border-bottom: 2px solid #1e73ed;"></div>
                                            <div style="text-align: center; font-size: medium; padding: 6px; cursor: pointer;" v-b-modal.modal-center @click="getDemographicByShelter('Female')">Details</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                        <div>
                                            <div class="title">Children</div>
                                            <div class="count" v-if="count_list_by_shelter.child">
                                                <span v-if="liveTracking && count_live_list.child>=0">{{ count_live_list.child }}/</span>
                                                {{ count_list_by_shelter.child }}</div>
                                            <div style="padding-top: 8px; border-bottom: 2px solid #1e73ed;"></div>
                                            <div style="text-align: center; font-size: medium; padding: 6px; cursor: pointer;" v-b-modal.modal-center @click="getDemographicByShelter('Children')">Details</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="mt-5 main-title text-right">Health Condition</p>
                            <div class="d-flex flex-column flex-md-row">
                                <div class="col-md-4">
                                    <router-link :to="{ path: '/house/list', query: { health_condition: 'Good',page:1, perPage:25,shelter:this.shelter } }">
                                        <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Good
                                                    <span>
                                                        <feather class="text-center" type="external-link" size="22"></feather>
                                                    </span>
                                                </div>
                                                <div class="count" v-if="count_list_by_shelter.good">
                                                    <span v-if="liveTracking && count_live_list.good>=0">{{ count_live_list.good }}/</span>
                                                    {{ count_list_by_shelter.good }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-md-4 margin-y-axis">
                                    <router-link :to="{ path: '/house/list', query: { health_condition: 'Sick', page:1, perPage:25 ,shelter:this.shelter} }">
                                        <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Sick
                                                    <span>
                                                        <feather class="text-center" type="external-link" size="22"></feather>
                                                    </span>
                                                </div>
                                                <div class="count" v-if="count_list_by_shelter.sick">
                                                    <span v-if="liveTracking && count_live_list.sick>=0">{{ count_live_list.sick }}/</span>{{ count_list_by_shelter.sick }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-md-4 margin-botton">
                                    <router-link :to="{ path: '/house/list', query: { health_condition: 'Disability',page:1, perPage:25 ,shelter:this.shelter} }">
                                        <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Disability
                                                    <span>
                                                        <feather class="text-center" type="external-link" size="22"></feather>
                                                    </span>
                                                </div>
                                                <div class="count" v-if="count_list_by_shelter.disability">
                                                    <span v-if="liveTracking && count_live_list.disability>=0">{{ count_live_list.disability }}/</span>
                                                    {{ count_list_by_shelter.disability }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>

                            <div class="d-flex flex-column flex-md-row margin-top">
                                <div class="col-md-2"></div>
                                <div class="col-md-4 margin-botton">
                                    <router-link :to="{ path: '/house/list', query: { health_condition: 'Pregnant',page:1, perPage:25,shelter:this.shelter} }">
                                        <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Pregnant
                                                    <span>
                                                        <feather class="text-center" type="external-link" size="22"></feather>
                                                    </span>
                                                </div>
                                                <div class="count" v-if="count_list_by_shelter.pregnant">
                                                    <span v-if="liveTracking && count_live_list.pregnant>=0">{{ count_live_list.pregnant }}/</span>{{ count_list_by_shelter.pregnant }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-md-4">
                                        <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title" style="padding-bottom: 2px;">Menstruation</div>
                                                <div class="count" v-if="count_list_by_shelter.menstruation">
                                                    <span v-if="liveTracking && count_live_list.menstruation>=0">{{ count_live_list.menstruation }}/</span>{{ count_list_by_shelter.menstruation }}</div>
                                            </div>
                                        </div>
                                </div>
                                <div class="col-md-2"></div>
                            </div>

                            <p class="mt-5 main-title">House Condition ({{ count_list_by_shelter.home }})</p>
                            <div class="d-flex flex-column flex-md-row">
                                <div class="col-md-3">
                                    <router-link :to="{ path: '/house/list', query: { house_condition: 'Multi-Stored',page:1, perPage:25,shelter:this.shelter} }">
                                        <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Multi-Stored
                                                    <span>
                                                        <feather class="text-center" type="external-link" size="22"></feather>
                                                    </span>
                                                </div>
                                                <div class="count" v-if="count_list_by_shelter.multi_stored_home">{{ count_list_by_shelter.multi_stored_home }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-md-3 margin-y-axis">
                                    <router-link :to="{ path: '/house/list', query: { house_condition: 'Concrete',page:1, perPage:25,shelter:this.shelter} }">
                                        <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Concrete
                                                    <span>
                                                        <feather class="text-center" type="external-link" size="22"></feather>
                                                    </span>
                                                </div>
                                                <div class="count" v-if="count_list_by_shelter.concrete_home">{{ count_list_by_shelter.concrete_home }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-md-3 margin-botton">
                                    <router-link :to="{ path: '/house/list', query: { house_condition: 'Tin-Shade',page:1, perPage:25,shelter:this.shelter} }">
                                        <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Tin-Shade
                                                    <span>
                                                        <feather class="text-center" type="external-link" size="22"></feather>
                                                    </span>
                                                </div>
                                                <div class="count" v-if="count_list_by_shelter.tin_home">{{ count_list_by_shelter.tin_home }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-md-3">
                                    <router-link :to="{ path: '/house/list', query: { house_condition: 'Mud-House',page:1, perPage:25,shelter:this.shelter} }">
                                        <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Mud-House
                                                    <span>
                                                        <feather class="text-center" type="external-link" size="22"></feather>
                                                    </span>
                                                </div>
                                                <div class="count" v-if="count_list_by_shelter.mud_home">{{ count_list_by_shelter.mud_home }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <loader />
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Demographic Details -->
    <b-modal id="modal-center" ref="modal" centered :title="demographic_title" size="s" hide-footer>
        <div v-if="demographic_title !== 'Children'">
            <div class="row mt-2">
                <div class="col-sm-12">
                    <div style="display: flex; gap: 20px; font-size: medium;">
                        <span style="width: 100px;">Good:</span>
                        <span v-if="details.good">{{details.good}}</span>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div style="display: flex; gap: 20px; font-size: medium;">
                        <span style="width: 100px;">Sick:</span>
                        <span v-if="details.sick">{{details.sick}}</span>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div style="display: flex; gap: 20px; font-size: medium;">
                        <span style="width: 100px;">Disability:</span>
                        <span v-if="details.disabled">{{ details.disabled }}</span>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="demographic_title == 'Female'">
                <div class="col-sm-12">
                    <div style="display: flex; gap: 20px; font-size: medium;">
                        <span style="width: 100px;">Pregnant:</span>
                        <span v-if="details.pregnant">{{ details.pregnant }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-sm-6">
                    <p style="display: flex; gap: 20px; font-size: medium;font-weight: 500">Male</p>
                    <div class="row mt-2">
                        <div class="col-sm-12">
                            <div style="display: flex; gap: 20px; font-size: medium;">
                                <span style="width: 100px;">Good:</span>
                                <span v-if="details.male.good>=0">{{details.male.good}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <div style="display: flex; gap: 20px; font-size: medium;">
                                <span style="width: 100px;">Sick:</span>
                                <span v-if="details.male.sick>=0">{{details.male.sick}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <div style="display: flex; gap: 20px; font-size: medium;">
                                <span style="width: 100px;">Disability:</span>
                                <span v-if="details.male.disabled>=0">{{ details.male.disabled }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <p style="display: flex; gap: 20px; font-size: medium; font-weight: 500;">Female</p>
                    <div class="row mt-2">
                        <div class="col-sm-12">
                            <div style="display: flex; gap: 20px; font-size: medium;">
                                <span style="width: 100px;">Good:</span>
                                <span v-if="details.female.good>=0">{{details.female.good}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <div style="display: flex; gap: 20px; font-size: medium;">
                                <span style="width: 100px;">Sick:</span>
                                <span v-if="details.female.sick>=0">{{details.female.sick}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <div style="display: flex; gap: 20px; font-size: medium;">
                                <span style="width: 100px;">Disability:</span>
                                <span v-if="details.female.disabled>=0">{{ details.female.disabled }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>

    <!-- Relief Calculation -->
    <b-modal id="modal-relief-center" ref="modal" centered title="Chart of Relief" size="lg" hide-footer>
        <div style="display: flex; justify-content: flex-end;">
            <b-button @click="downloadPDF">Download PDF</b-button>
        </div>

        <div id="download-section">
            <div style="display: flex; flex-direction: column; font-size: medium;">
                <span>Shelter: {{ selectedShelterName  }}</span>
                <span style="margin-top: 12px;">Date: {{ date }}</span>
            </div>

            <div class="table-responsive datatable-vue mt-4">
                <b-table show-empty stacked="md" :items="relief_totals" :fields="tablefields">
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>

                    <template #cell(name)="row">
                        <div v-if="row.item.name">
                            <span>{{ row.item.name }}</span>
                        </div>
                    </template>

                    <template #cell(amount)="row">
                        <div v-if="row.item.amount">
                            <span>{{ row.item.amount }} {{ row.item.unit }}</span>
                        </div>
                    </template>

                    <template #cell(total_member)="row">
                        <div v-if="row.item.total_member">
                            <span>{{ row.item.total_member }}</span>
                        </div>
                        <div v-else>
                            <span>0</span>
                        </div>
                    </template>

                    <template #cell(totalAmount)="row">
                        <div v-if="row.item.amount">
                            <span>{{ row.item.totalAmount }} {{ row.item.unit }}</span>
                        </div>
                    </template>

                    <template #cell(type)="row">
                        <div v-if="row.item.type">
                            <span v-if="row.item.type == 'adult'" style="text-transform: capitalize; background-color: #1e73ed; color: white; padding: 4px 8px; border-radius: 0.375rem;">Adult</span>
                            <span v-else-if="row.item.type == 'child'" style="text-transform: capitalize; background-color: #007bff; color: white; padding: 4px 8px; border-radius: 0.375rem;">Child</span>
                            <span v-else-if="row.item.type == 'pregnant'" style="text-transform: capitalize; background-color: #1e73ed; color: white; padding: 4px 8px; border-radius: 0.375rem;">Pregnant</span>
                            <span v-else-if="row.item.type == 'sick'" style="text-transform: capitalize; background-color: #374151; color: white; padding: 4px 8px; border-radius: 0.375rem;">Sick</span>
                            <span v-else-if="row.item.type == 'menstruation'" style="text-transform: capitalize; background-color: #6c757d; color: white; padding: 4px 8px; border-radius: 0.375rem;">Menstruation</span>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import loader from '../loader/loader.vue';
import moment from "moment";
import { jsPDF } from 'jspdf';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        Multiselect,
        loader
    },

    data() {
        return {
            demographic_title: null,
            liveTracking: false,
            date: null,
            shelter: null,
            details: {
                good: null,
                sick: null,
                disabled: null,
                pregnant: null,
            },
            initialLoad: true,
            relief_totals: [],
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: false 
                },
                {
                    key: 'amount',
                    label: 'Unit Amount',
                    sortable: false 
                },
                {
                    key: 'total_member',
                    label: 'Total Member',
                    sortable: false 
                },
                {
                    key: 'totalAmount',
                    label: 'Total Amount',
                    sortable: false 
                },
                {
                    key: 'type',
                    label: 'Type',
                    sortable: false 
                }
            ],
            selectedShelterName: 'None'
        }
    },

    computed: {
        ...mapState({
            relief_items: state => state.relief.relief_list,
            shelter_list: state => state.shelter.shelter,
            count_list_by_shelter: state => state.dashboard.dashboard_count_by_shelter,
            count_live_list: state => state.dashboard.dashboadr_count_by_shelter_live,
            demographic_count: state => state.dashboard.demographic_count_by_shelter,
            demographic_count_live: state => state.dashboard.demographic_count_by_shelter_live,

            loading: state => state.dashboard.dashboardCountLoading,
            error: state => state.dashboard.dashboardCountError,
        }),

        totalAdults() {
            return this.count_live_list.male + this.count_live_list.female;
        },

        totalChildren() {
            return this.count_live_list.child;
        },

        totalSick() {
            return this.count_live_list.sick;
        },

        totalPregnant() {
            return this.count_live_list.pregnant;
        },

        totalMenstruation() {
            return this.count_live_list.menstruation;
        },

        formattedShelters() {
            const shelters = [{
                    value: '',
                    text: 'Select a Shelter',
                    disabled: true
                },
                ...this.shelter_list.map(shelter => ({
                    value: shelter.id,
                    text: shelter.name
                }))
            ];
            if (shelters.length > 1 && !this.shelter) {
                this.shelter = shelters[1].value;
            }
            return shelters;
        }
    },

    watch: {
        count_list_by_shelter(newValue, oldValue) {

        },

        count_live_list(newValue, oldValue) {

        },

        shelter_list(newList) {
            if (newList.length > 0 && !this.shelter) {
                this.shelter = newList[0].id;
            }
        },

        shelter(newShelter) {
            const selected = this.shelter_list.find(s => s.id === newShelter);
            this.selectedShelterName = selected ? selected.name : 'None';

            if (this.initialLoad && newShelter) {
                this.$store.dispatch("dashboard/fetchDashboardCountByShelter", {
                    shelter: newShelter
                });
            }
            if (this.liveTracking && newShelter) {
                this.date = moment(String(this.date)).format("YYYY-MM-DD");
                this.$router.replace({
                    path: '/dashboard/shelter',
                    query: {
                        date: this.date,
                        shelter: this.shelter
                    }
                });
                this.$store.dispatch("dashboard/fetchDashboardCountByShelterLiveTracking", {
                    date: this.date,
                    shelter: newShelter
                });
            }
        },

        date(newDate) {
            if (this.liveTracking && newDate) {
                this.date = moment(String(newDate)).format("YYYY-MM-DD");
                this.$router.replace({
                    path: '/dashboard/shelter',
                    query: {
                        date: this.date,
                        shelter: this.shelter
                    }
                });
                this.$store.dispatch("dashboard/fetchDashboardCountByShelterLiveTracking", {
                    date: this.date,
                    shelter: this.shelter
                });
            }
        }
    },

    mounted() {
        this.$store.dispatch("relief/fetchRelief")
        this.$store.dispatch("shelter/fetchShelter");

        if (this.$route.query.only_shelter) {
            this.shelter = this.$route.query.only_shelter;
            this.$store.dispatch("dashboard/fetchDashboardCountByShelter", {
                shelter: this.shelter
            });
        }
        if (this.$route.query.shelter && this.$route.query.date) {
            this.liveTracking = true
            this.shelter = this.$route.query.shelter;
            this.date = this.$route.query.date;
            this.$store.dispatch("dashboard/fetchDashboardCountByShelter", {
                shelter: this.shelter
            }).then(() => {
                this.$store.dispatch("dashboard/fetchDashboardCountByShelterLiveTracking", {
                    shelter: this.shelter,
                    date: this.date
                });
            });
        }
    },

    methods: {
        async downloadPDF() {
            try {
                const element = document.querySelector('#download-section');
                if (!element) {
                    console.error("Element with ID 'download-section' not found!");
                    return;
                }

                element.classList.add('pdf-export');

                // Force re-render to apply page breaks
                await new Promise((resolve) => requestAnimationFrame(resolve));

                // Initialize jsPDF with exact A4 dimensions
                const pdf = new jsPDF({
                    orientation: 'portrait',
                    unit: 'px',
                    format: [595, 842], // A4 size in pixels at 72 DPI
                    compress: true
                });

                await pdf.html(element, {
                    callback: (pdf) => {
                        pdf.save('relief-calculation.pdf'); // Download the PDF
                        element.classList.remove('pdf-export');
                    },
                    margin: [36, 26, 36, 26],  // Small margins
                    autoPaging: 'text',       // Automatically paginate content
                    x: 0,
                    y: 0,
                    width: 595,               // Match A4 width exactly
                    windowWidth: element.scrollWidth, // Proper scaling
                    html2canvas: {
                        scale: 0.7,  // Higher resolution for better quality
                        useCORS: true, // Fix external image loading issues
                    }
                });

                console.log('PDF successfully downloaded!');
            } catch (error) {
                console.error('Error generating PDF:', error);
            }
        },

        calculateRelief() {
            this.relief_totals = this.relief_items.map(item => {
                let totalAmount = 0;
                let total_member = 0;
                // console.log(item)
                if (item.type === 'adult') {
                    totalAmount = item.amount * this.totalAdults;
                    total_member = this.totalAdults;
                } else if (item.type === 'child') {
                    totalAmount = item.amount * this.totalChildren;
                    total_member = this.totalChildren;
                } else if (item.type === 'sick') {
                    totalAmount = item.amount * this.totalSick;
                    total_member = this.totalSick;
                } else if (item.type === 'pregnant') {
                    totalAmount = item.amount * this.totalPregnant;
                    total_member = this.totalPregnant;
                } else if (item.type === 'menstruation') {
                    totalAmount = item.amount * this.totalMenstruation;
                    total_member = this.totalMenstruation;
                } 

                totalAmount = (isNaN(totalAmount) || totalAmount == null || totalAmount === 0) ? 0 : totalAmount;

                return {
                    id: item.id,
                    name: item.name,
                    amount: item.amount,
                    totalAmount: totalAmount,
                    unit: item.unit,
                    type: item.type,
                    total_member: total_member
                };
            });
        },

        updateShelter() {
            this.$router.replace({
                path: '/dashboard/shelter',
                query: {
                    shelter: this.shelter
                }
            });

            this.$store.dispatch("dashboard/fetchDashboardCountByShelter", {
                shelter: this.shelter
            });

            if (this.liveTracking) {
                this.date = moment(String(this.date)).format("YYYY-MM-DD");
                this.$store.dispatch("dashboard/fetchDashboardCountByShelterLiveTracking", {
                    date: this.date,
                    shelter: this.shelter,
                }).then((response) => {
                    this.count_live_list = response.data
                });
            }
        },

        getDemographicByShelter(demo) {
            this.details = {}
            this.demographic_title = demo
           
            if (!this.liveTracking) {
                this.$store.dispatch("dashboard/fetchDashboardDemographicCountByShelter", this.shelter).then((response) => {
                    if (demo === 'Male') {
                   this.details = response.data.male
                } else if (demo === 'Female') {
                    this.details = response.data.female
                } else if (demo === 'Children') {
                    this.details = response.data.child
                    
                }
                        
                    });
               
            } else {
                if (demo === 'Male') {
                    if (this.date !== null) {
                        this.date = moment(String(this.date)).format("YYYY-MM-DD");
                        this.$store.dispatch("dashboard/fetchDashboardDemographicCountByShelterLive", {
                            shelter: this.shelter,
                            date: this.date
                        }).then((response) => {
                            this.details = response.data.male
                        });
                    }
                } else if (demo === 'Female') {
                    if (this.date !== null) {
                        this.date = moment(String(this.date)).format("YYYY-MM-DD");
                        this.$store.dispatch("dashboard/fetchDashboardDemographicCountByShelterLive", {
                            shelter: this.shelter,
                            date: this.date
                        }).then((response) => {
                            this.details = response.data.female
                        });
                    }
                } else if (demo === 'Children') {
                    if (this.date !== null) {
                        this.date = moment(String(this.date)).format("YYYY-MM-DD");
                        this.$store.dispatch("dashboard/fetchDashboardDemographicCountByShelterLive", {
                            shelter: this.shelter,
                            date: this.date
                        }).then((response) => {
                            this.details = response.data.child
                        });
                    }
                }
            }
        },

        toggleLive() {
            if (!this.liveTracking) {
                this.liveTracking = true;
                if (!this.$route.query.date) {
                    this.date = new Date();
                    if (this.date !== null) {
                        this.date = moment(String(this.date)).format("YYYY-MM-DD");
                        this.$router.replace({
                            path: '/dashboard/shelter',
                            query: {
                                date: this.date,
                                shelter: this.shelter
                            }
                        });

                        this.$store.dispatch("dashboard/fetchDashboardCountByShelterLiveTracking", {
                            date: this.date,
                            shelter: this.shelter
                        })
                    }
                }else{
                    this.date = this.$route.query.date
                    this.$router.replace({
                        path: '/dashboard/shelter',
                        query: {
                            date: this.date,
                            shelter: this.shelter
                        }
                    });

                    this.$store.dispatch("dashboard/fetchDashboardCountByShelterLiveTracking", {
                        date: this.date,
                        shelter: this.shelter
                    })
                }
            } else {
                this.liveTracking = !this.liveTracking
                this.date = null
                this.$router.replace({
                    path: '/dashboard/shelter'
                });
            }
        }
    }
};
</script>

<style scoped>
.margin-y-axis {
    margin-top: 16px;
    margin-bottom: 16px;
}

.margin-top {
    margin-top: 24px;
}

.margin-botton {
    margin-bottom: 16px;
}

.border-class {
    border-radius: 0.375rem;
}

.title {
    font-size: large;
    font-weight: 500;
    color: #1e73ed;
}

.count {
    text-align: end;
    font-size: xx-large;
    font-weight: 500;
    padding-right: 28px;
}

.main-title {
    font-size: x-large;
    font-weight: 500;
}

@media (max-width: 1480px) {
    .main-title {
        font-size: large;
        font-weight: 500;
    }
}

@media (max-width: 767px) {
    .count {
        padding-right: 12px;
    }

    .margin-top {
        margin-top: 0px;
    }
}

@media (min-width: 768px) {
    .margin-y-axis {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .margin-botton {
        margin-bottom: 0px;
    }
}
</style>
